import React, { useState } from 'react'
import DatePicker from '../../../shared/DatePicker'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import CustomButton from '../../../shared/CustomButton'
import { useGetPayersQuery } from '../../../redux/api/modules/claimsApi'
import DropdownField from '../../../shared/DropdownField'
import { patientOptionsFormat } from '../../../constants/BeneficiaryConstants'
import AutoCompleteField from '../../../shared/AutoCompleteField'
import TextInput from '../../../shared/TextInput'
import ReusableModal from '../../../shared/ReuseableModal'
import BulkProcessClaimsModal from './BulkProcessClaimsModal'
import { MdBatchPrediction } from 'react-icons/md'

function ClaimGenerationFilters ({
  payloadData,
  setPayloadData,
  applyFilters,
  resetFilters,
  fetchNewData,
  loading
}) {
  const { t } = useTranslation()
  const { data: payersResponse, isLoading: fieldLoading } = useGetPayersQuery({})
  const payerList = payersResponse?.data || []
  const [showBulkProcessModal, setShowBulkProcessModal] = useState(false)

  const claimStatusOptions = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "submitted", label: "Submitted" },
    { value: "failed", label: "Failed" }
  ]

  const handleChange = event => {
    const { name, value } = event.target || {}
    setPayloadData(prevValues => ({
      ...prevValues,
      [name]: moment(value).format('YYYY-MM-DD')
    }))
  }

  const handleTypeChange = e => {
    setPayloadData({
      ...payloadData,
      payer_id: e.target?.value
    })
  }

  const handleApplyFilters = () => {
    applyFilters()
  }

  const handleResetFilters = () => {
    resetFilters()
  }

  const handleBulkProcess = () => {
    setShowBulkProcessModal(true)
  }
  return (
    <>
      <div className='flex flex-wrap gap-2 mb-2'>
        <div className='w-[200px]'>
          <DatePicker
            name='start_date'
            value={
              payloadData?.start_date
                ? moment(payloadData?.start_date, 'YYYY-MM-DD').toDate()
                : ''
            }
            onChange={handleChange}
            useFormik={false}
            placeholder={t('StartDate')}
          />
        </div>

        <div className='w-[200px]'>
          <DatePicker
            name='end_date'
            value={
              payloadData?.end_date
                ? moment(payloadData?.end_date, 'YYYY-MM-DD').toDate()
                : ''
            }
            onChange={handleChange}
            useFormik={false}
            placeholder={t('EndDate')}
          />
        </div>

        <div className='w-[200px]'>
          <TextInput
            useFormik={false}
            value={payloadData?.patient_filenumber}
            onChange={e =>
              setPayloadData({
                ...payloadData,
                patient_filenumber: e.target.value
              })
            }
            placeholder={t('MRN')}
          />
        </div>

        <div className='w-[200px]'>
          <TextInput
            useFormik={false}
            value={payloadData?.patient_document_id}
            onChange={e =>
              setPayloadData({
                ...payloadData,
                patient_document_id: e.target.value
              })
            }
            placeholder={t('patient_document_id')}
          />
        </div>

        <div className='w-[200px]'>
          <DropdownField
            filter
            useFormik={false}
            options={claimStatusOptions}
            placeholder={t('Claim Status')}
            handleChange={e =>
              setPayloadData({
                ...payloadData,
                claim_status: e.target.value
              })
            }
            value={payloadData?.claim_status}
          />
        </div>

        <div className='w-[200px]'>
          <DropdownField
            filter
            useFormik={false}
            options={payerList?.map(py => ({
              value: py?.payer_id,
              label: py?.name
            }))}
            loading={fieldLoading}
            placeholder={t('Select Payer')}
            handleChange={e => handleTypeChange(e)}
            value={payloadData?.payer_id}
          />
        </div>

        <div className='flex gap-2 items-start flex-wrap'>
          <CustomButton
            title={t('ApplyFilters')}
            buttonType='primary'
            icon={'pi pi-filter'}
            className='w-fit h-[35px]'
            disabled={loading}
            onClick={handleApplyFilters}
          />
          <CustomButton
            title={t('Reset')}
            buttonType='reset'
            icon={'pi pi-sync'}
            disabled={loading}
            className='w-fit h-[35px]'
            onClick={handleResetFilters}
          />
          <CustomButton
            label={t('Bulk Generations')}
            icon='pi pi-cog'
            buttonType='primary'
            className='w-fit h-[35px]'
            onClick={handleBulkProcess}
          />
        </div>
      </div>
      <ReusableModal
        position='top'
        isVisible={showBulkProcessModal}
        title={t('Bulk Claims Generation')}
        HeaderIcon={MdBatchPrediction}
        onClose={() => setShowBulkProcessModal(false)}
        className='w-full lg:w-[80%]'
      >
        <BulkProcessClaimsModal
          onClose={() => setShowBulkProcessModal(false)}
          onComplete={fetchNewData}
        />
      </ReusableModal>
    </>
  )
}

export default ClaimGenerationFilters
